import { List } from '@customerio/pluma-components/react';
import type { Highlight } from '@/services/billing/types';
import { PlanType } from '@/services/billing/plans';
import { PlanHighlightItem } from './plan-highlight-item';

type PlanHighlightsProps = {
  highlights: Highlight[];
  planType?: PlanType;
  /** CDP plans never get the appended "Premium Integrations" item. Always false for Journeys plans. */
  isCdpPlan: boolean;
};

/** A stable list key for a highlight (its text, or its label for link/route highlights). */
function highlightKey(highlight: Highlight): string {
  return typeof highlight === 'string' ? highlight : highlight.label;
}

/**
 * The bulleted plan-highlights list. Renders each highlight as a {@link PlanHighlightItem}, then
 * appends a "Premium Integrations" item for the Premium and Enterprise plans (non-CDP).
 */
export function PlanHighlights({ highlights, planType, isCdpPlan }: PlanHighlightsProps) {
  const showPremiumIntegrations = !isCdpPlan && (planType === PlanType.Premium || planType === PlanType.Enterprise);

  return (
    <List my="150" px="150" pt="100" gap="150" styleType="none" data-test-plan-highlights>
      {highlights.map((highlight) => (
        <PlanHighlightItem key={highlightKey(highlight)} highlight={highlight} />
      ))}
      {showPremiumIntegrations ? <PlanHighlightItem highlight="Premium Integrations" /> : null}
    </List>
  );
}
